import Vue from 'vue'
import { GLACCT_INIT_LOADING, GLACCT_INIT_SUCCESS, GLACCT_INIT_FAIL, GLMAPPING_COMMIT_KEY, GLACCTNO_COMMIT_KEY } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  glMapping: {
    glMappingKey: {
      glapplnInt: null,
      sepAcctCtyRisk: null,
      sepAcctDri: null,
      sepAcctBrn: null,
      sepAcctPolType: null,
      sepAcctBusCls: null,
      sepAcctDept: null,
      sepAcctCtyCed: null,
      sepAcctCtyRi: null,
      sepAcctResCat: null,
      sepAcctStmtLvl: null,
      sepAcctStmtLnGL: null,
      sepAcctBAGL: null,
      sepAcctCedAreaGL: null,
      sepAcctRIAreaGL: null,
      sepAcctCesCat: null,
      sepAcctRiskAreaGL: null
    }
  },
  glAcctNo: {
    glAcctNoId: {
      branch: null,
      glacctNo: null,
      fund: null,
      acctNoSfx: null,
      postType: null,
      curr: null
    },
    updateCnt: 0
  }
}

const getters = {

}

const mutations = {
  [GLACCT_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [GLACCT_INIT_SUCCESS](state, data) {
    state.init = 1
    Vue.set(state, 'menu', data.menu)
    state.initErr = []
  },
  [GLACCT_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [GLMAPPING_COMMIT_KEY](state, data) {
    state.glMapping.glMappingKey.glapplnInt = data.glapplnInt
    state.glMapping.glMappingKey.sepAcctCtyRisk = data.sepAcctCtyRisk
    state.glMapping.glMappingKey.sepAcctDri = data.sepAcctDri
    state.glMapping.glMappingKey.sepAcctBrn = data.sepAcctBrn
    state.glMapping.glMappingKey.sepAcctPolType = data.sepAcctPolType
    state.glMapping.glMappingKey.sepAcctBusCls = data.sepAcctBusCls
    state.glMapping.glMappingKey.sepAcctDept = data.sepAcctDept
    state.glMapping.glMappingKey.sepAcctCtyCed = data.sepAcctCtyCed
    state.glMapping.glMappingKey.sepAcctCtyRi = data.sepAcctCtyRi
    state.glMapping.glMappingKey.sepAcctResCat = data.sepAcctResCat
    state.glMapping.glMappingKey.sepAcctStmtLvl = data.sepAcctStmtLvl
    state.glMapping.glMappingKey.sepAcctStmtLnGL = data.sepAcctStmtLnGL
    state.glMapping.glMappingKey.sepAcctBAGL = data.sepAcctBAGL
    state.glMapping.glMappingKey.sepAcctCedAreaGL = data.sepAcctCedAreaGL
    state.glMapping.glMappingKey.sepAcctRIAreaGL = data.sepAcctRIAreaGL
    state.glMapping.glMappingKey.sepAcctCesCat = data.sepAcctCesCat
    state.glMapping.glMappingKey.sepAcctRiskAreaGL = data.sepAcctRiskAreaGL
    const commit = {
      glapplnInt: data.glapplnInt,
      sepAcctCtyRisk: data.sepAcctCtyRisk,
      sepAcctDri: data.sepAcctDri,
      sepAcctBrn: data.sepAcctBrn,
      sepAcctPolType: data.sepAcctPolType,
      sepAcctBusCls: data.sepAcctBusCls,
      sepAcctDept: data.sepAcctDept,
      sepAcctCtyCed: data.sepAcctCtyCed,
      sepAcctCtyRi: data.sepAcctCtyRi,
      sepAcctResCat: data.sepAcctResCat,
      sepAcctStmtLvl: data.sepAcctStmtLvl,
      sepAcctStmtLnGL: data.sepAcctStmtLnGL,
      sepAcctBAGL: data.sepAcctBAGL,
      sepAcctCedAreaGL: data.sepAcctCedAreaGL,
      sepAcctRIAreaGL: data.sepAcctRIAreaGL,
      sepAcctCesCat: data.sepAcctCesCat,
      sepAcctRiskAreaGL: data.sepAcctRiskAreaGL
    }
    sessionStorage.setItem('glMapping', JSON.stringify(commit))
  },
  [GLACCTNO_COMMIT_KEY](state, data) {
    state.glAcctNo.glAcctNoId.branch = data.branch
    state.glAcctNo.glAcctNoId.glacctNo = data.glacctNo
    state.glAcctNo.glAcctNoId.fund = data.fund
    state.glAcctNo.glAcctNoId.acctNoSfx = data.acctNoSfx
    state.glAcctNo.glAcctNoId.postType = data.postType
    state.glAcctNo.glAcctNoId.curr = data.curr
    state.glAcctNo.updateCnt++
  }
}

const actions = {
  async glAcctManagementInit({ commit, dispatch, rootState }) {
    const apiUrl = rootState.app.menu.glAcctManagement
    commit(GLACCT_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(GLACCT_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(GLACCT_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
